import type { RecordView } from '@kit/sync/types/record-view';
import { CloudUpload } from 'lucide-react';
import { useTranslation } from '@/shared/i18n/use-translation';
import { formatTimestamp } from '@/shared/lib/dates/format-timestamp';

type RecordMetaProps = {
  readonly view: RecordView<unknown>;
  readonly nameOf: (userId: string) => string;
};

export function RecordMeta({ view, nameOf }: RecordMetaProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-1 border-t pt-4 text-xs text-muted-foreground">
      <span>
        {t('Created by {name} · {when}', {
          name: nameOf(view.created_by),
          when: formatTimestamp(view.created_at),
        })}
      </span>
      {view.updated_at !== view.created_at && (
        <span>
          {t('Changed by {name} · {when}', {
            name: nameOf(view.updated_by),
            when: formatTimestamp(view.updated_at),
          })}
        </span>
      )}
      {view.pending && (
        <span className="flex items-center gap-1">
          <CloudUpload className="size-3" /> {t('Changes saved on this device, waiting to be sent')}
        </span>
      )}
    </div>
  );
}
